export default __webpack_public_path__ + "static/media/img-0808-czech-republc-full-face.bc139b98.png";